import { OrderPaymentsApiRemoteService } from '../../Services/api/OrderPayments/order-payments-service'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ReprocessOrderPaymentsUseCase
implements IFormUsecase<string, void> {
  constructor (private readonly OrderPaymentsApi: OrderPaymentsApiRemoteService) {}
    

  public async handle (
    orderId: string
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.OrderPaymentsApi.reprocess(orderId)

      if (response.isFailure) {
        return response
      }
    
      
    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
